import { Component, OnInit } from '@angular/core';
import dayjs from 'dayjs';
import {
  IProject,
  IUsersHours,
  TimelogsRepository,
} from '../../../state/timelogs.repository';
import { TimelogsService } from '../../../state/timelogs.service';
import { DatalistOption } from 'app/state/abstract/base.repository';

@Component({
  selector: 'app-timelogs-overview',
  templateUrl: './timelogs-overview.component.html',
  styleUrls: ['./timelogs-overview.component.scss'],
})
export class TimelogsOverviewComponent implements OnInit {
  constructor(
    public service: TimelogsService,
    public repository: TimelogsRepository
  ) {}

  usersTotal: IUsersHours[] = [];
  usersTotalResult: IUsersHours[] = [];
  projectsWithDates?: IProject[] = [];
  selectedProjectId: IProject | null = null;
  StartDate: dayjs.Dayjs = dayjs().startOf('year').add(1, 'day');
  EndDate: dayjs.Dayjs = dayjs().endOf('year');
  startDateForProject: string = this.StartDate.toISOString().slice(0, 10);
  endDateForProject: string = this.EndDate.toISOString().slice(0, 10);

  projectOptions: DatalistOption[] | null = null;
  projects: IProject[] = [];
  ngOnInit(): void {
    this.updateValue();
  }
  updateValue() {
    this.projectsWithDates = [];
    this.service.loadAll().subscribe({
      next: (x) => {
        this.projects = x;
        this.projects.forEach((x) => {
          this.service
            .loadTaskMarksForTeamHours(
              x.id,
              this.startDateForProject,
              this.endDateForProject
            )
            .subscribe({
              next: (z) => {
                this.projectsWithDates?.push(z);
                z.usersTotals.forEach((y) => {
                  this.usersTotal.push(y);
                });
              },
              complete: () => {
                const uniqueUserId = this.usersTotal
                  .map((item) => item.id)
                  .filter(
                    (value, index, self) => self.indexOf(value) === index
                  );
                this.usersTotalResult = uniqueUserId.map((item) => {
                  var nameById = this.usersTotal.find(
                    (element) => element.id == item
                  );
                  return {
                    id: item,
                    name: nameById!.name,
                    hours: 0,
                  };
                });
                this.usersTotal.forEach((hourElement) => {
                  this.usersTotalResult.find(
                    (id) => id.id == hourElement.id
                  )!.hours += hourElement?.hours;
                });
              },
            });
        });
      },
    });
  }
}
